<section class="tender-dialog custom-scrollbar">
  <!-- dialog header -->
  <div class="tender-dialog__header">
    <!-- dialog title -->
    @if (dialogData?.title) {
      <h4 class="tender-dialog__title">
        {{ dialogData.title | translate }}
      </h4>
    }

    <!-- close button -->
    <button (click)="close()">
      <i class="iconsax tender-dialog__icon" icon-name="x"></i>
    </button>
  </div>
  <!-- dialog content -->
  <form
    class="tender-dialog__form"
    [formGroup]="proposalForm"
    (submit)="submitBid()">
    <!-- price filed -->
    <pwj-input
      class="tender-dialog__input"
      icon="coins-3"
      iconPosition="left"
      placeholder="proposalForm.enterYourPrice"
      label="proposalForm.price"
      formControlName="price"></pwj-input>
    <!-- eta field -->
    <pwj-input
      formControlName="eta"
      class="tender-dialog__input"
      type="number"
      icon="clock"
      iconPosition="left"
      placeholder="proposalForm.enterPreparationTime"
      label="proposalForm.productPreparationTime"></pwj-input>
    <!-- delivery city -->
    <pwj-input
      class="tender-dialog__input"
      icon="map-3"
      iconPosition="left"
      placeholder="proposalForm.enterDeliveryCity"
      label="proposalForm.deliveryCity"
      formControlName="delivery_city"></pwj-input>

    <!-- description input -->
    <pwj-input
      icon="stickynote"
      iconPosition="left"
      [isTextAreaMode]="true"
      placeholder="proposalForm.description"
      label="proposalForm.enterDescription"
      rows="3"
      formControlName="description">
    </pwj-input>

    <!-- upload file input -->
    <div class="tender-dialog__upload">
      <pwj-upload-files
        multiple
        label="proposalForm.files"
        formControlName="media_ids"
        [wFull]="true"></pwj-upload-files>
    </div>

    <div class="tender-dialog__footer">
      <!-- dialog message -->
      <div class="dialog-message">
        <!-- no access warning -->
        @if (!hasAccessToCreateProposal) {
          <span class="dialog-message__icon">
            <i class="info-name__icon iconsax" icon-name="info-circle"></i>
          </span>
          <span class="dialog-message__text">
            {{ 'global.accessDeniedDescription' | translate }}
          </span>
        }
      </div>

      <!-- submit button -->
      <pwj-button
        [ngClass]="{ 'cursor-not-allowed': !hasAccessToCreateProposal }"
        class="submit-btn"
        variant="primary"
        size="medium"
        icon="chevron-right"
        [rotateIconInRtl]="true"
        [iconReversePosition]="true"
        type="submit"
        [disabled]="
          !hasAccessToCreateProposal ||
          proposalForm.invalid ||
          isDisabledSubmitBtn ||
          formIsSubmitting
        "
        >{{ 'global.send' | translate }}</pwj-button
      >
    </div>
  </form>
</section>
